<template>
    <div class="form-land-modal" v-if="formSetUp != null">
        <button class="btn-close-form-modal" @click="closeFormModal()"><svgIcon name="close" class="icon-close"/></button>
        <div class="form-titles" v-if="formVisible">
            <div class="form-bg" :style="'background-image: url(' + formSetUp.form_drop_modal.form_img + ')'"></div>
            <div class="titles">
                <h3>{{formSetUp.form_drop_modal.form_title}}</h3>
                <span>{{formSetUp.form_drop_modal.form_title_desc}}</span>
            </div>
        </div>
        <div class="form-modal-container">
            <Form class="form_call-modal" @submit="onSubmit" :validation-schema="schema" v-slot="{ errors }" v-if="formVisible">
                <div class="form-in" :class="{'disabled-form' : formDisabled}">
                    <TextInput
                        name="name"
                        type="text"
                        :placeholder="formSetUp.inputname"
                        :class="{'error' : errors.name}"
                    />
                    <TextInput
                        name="phone"
                        type="text"
                        :placeholder="formSetUp.inputphone"
                        v-maska="'+7 (###) ###-##-##'"
                        :class="{'error' : errors.phone}"
                    />
                    <VueRecaptcha
                        ref="recaptchaFormLandModal"
                        @verify="onCaptchaVerified"
                        :sitekey="gCap_siteKey"
                        size="invisible"
                    />
                    <div class="btn-send">
                        <button class="btn btn-submit btn-success" type="submit" :disabled="errors.name || errors.phone">{{formSetUp.btn_name}}</button>
                    </div>
                </div>
                
            </Form>
            <div class="successMessage" v-if="!formVisible">
                <h3>{{formSetUp.form_success_msg}}</h3>
            </div>
            <div class="privacy-desc" v-if="formVisible">
                <p>
                    <span>{{ formSetUp.form_privacy_desc.one }}</span> 
                    «<span>{{ formSetUp.btn_name }}</span>»
                    <span class="two">{{ formSetUp.form_privacy_desc.two }}</span>
                    <span><a href="https://sales.bazis.kz/privacy-policy" target="_blank">{{formSetUp.form_privacy_desc.word }}</a></span>
                    <span class="three">{{ formSetUp.form_privacy_desc.three }}</span>
                </p>
            </div>
            <div class="to-many-requests-msg" v-if="toManySendingMsg">
                <span v-if="globalLang == ''">Вы отправили слишком много заявок, попробуйте позднее</span>
                <span v-if="globalLang == 'kz/'">Сіз жіберді тым көп өтінімдерді көріңіз кешіктірмей</span>
                <span v-if="globalLang == 'en/'">You have sent too many requests, please try again later</span>
            </div>
        </div>
    </div>
</template>

<script>
    import { Form } from "vee-validate";
    import * as Yup from "yup";
    import { ref } from 'vue'
    import TextInput from "@/components/forms/TextInput.vue";
    import svgIcon from '@/components/partials/SvgIcon.vue';
    import cookie from 'vue-cookie'
    import {mapGetters} from 'vuex'
    import { VueRecaptcha } from 'vue-recaptcha';
    export default {
        name: 'FormConsultLandModal',
        data () {
            return {
                globalLang: window.GlobalLang, 
                toManySendingMsg: false,
                phone: '',
                name: '',
                agree: false,
                errorMsg: false,
                formVisible: true,
                formDisabled: false,
                utmUrlParams: {},
            }
        },
        components: {
            TextInput,
            Form,
            svgIcon,
            VueRecaptcha,
        },
        computed: mapGetters({
            formSetUp: 'loadFormSetUp',
            gCap_siteKey: 'loadGcap_sitekey',
        }),
        setup() {
            const schema = Yup.object().shape({
                name: Yup.string()
                    .required('Title is required')
                    .matches(/^([а-яА-ЯёЁa-zA-Z].*[\s\.]*){3,35}$/),
                phone: Yup.string()
                    .required('First Name is required')
                    .matches(/^\+7\s?\((700|701|702|703|704|705|706|707|708|709|747|771|775|776|777|778)\)\s?\d{3}-\d{2}-\d{2}$/,),
            });
            return {
                schema,
            };
        },
        methods: {
            onCaptchaVerified(response) {
                let submissionCounter = localStorage.getItem('TheOne_submissionCounter') || 0;
                let lastSubmissionTime = localStorage.getItem('TheOne_lastSubmissionTime') || 0;
                var currentMinutes = this.getCurrentMinutes();
                if (currentMinutes - lastSubmissionTime >= 5) {
                    submissionCounter = 0;
                }
                if (submissionCounter >= 5) {
                    this.toManySendingMsg = true;
                    console.log('Превышен лимит отправок формы. Пожалуйста, подождите некоторое время.');
                    return;
                } else {
                    this.getQueryParams(submissionCounter, lastSubmissionTime);
                }
                // console.log(response)
                // console.log('start sending verify is complete');
                // this.formVisible = false;
                // var data = {
                //     'name': this.name,
                //     'phone': this.phone,
                //     'project' : 'The One',
                //     'secret_key' : '0L3QtSDRgdGD0LnRgtC1INGB0LLQvtC5INC90L7RgQ==',
                // };
                // console.log(data);
                // var querystring = require('querystring');
                // axios.post('https://admin.sales.bazis.kz/server/form-call.php', querystring.stringify(data))
                // .then(() => {
                //     submissionCounter++;
                //     localStorage.setItem('TheOne_submissionCounter', submissionCounter);
                //     localStorage.setItem('TheOne_lastSubmissionTime', currentMinutes);
                //     dataLayer.push({'event' : 'form_sent'})
                // })
                // .catch(error => {
                //     console.error('Form Page submission error:', error);
                // });
            },
            onSubmit(values) {
                this.name = values.name;
                this.phone = values.phone;
                this.$refs.recaptchaFormLandModal.execute();
            },
            getQueryParams(counter, time) {
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                for (const [key, value] of urlParams.entries()) {
                    this.utmUrlParams[key] = value;
                }
                this.sendData(counter, time);
            },
            sendData(counter, time) {
                this.formDisabled = true;
                var dataForm = {
                    leadName: this.name,
                    phone: this.normalizePhone(this.phone),
                    complex: 'The ONE',
                    email: '',
                    advertisingChannel: "199", 
                    advertisingChannelCode: "199",
                    advertisingChannelName: "Сайт жилого комплекса",

                    leadChannelCode: 'WEBSITE_REST_PRIVATE_OFFICE',
                    leadChannelName: "Личный кабинет",
                    requestWebsite: 'the-one.bazis.kz',

                    description:
                    "Form Modal" +
                    (this.utmUrlParams.utm_source ? ` | Utm Source: ${this.utmUrlParams.utm_source}` : '') +
                    (this.utmUrlParams.utm_medium ? ` | Utm Medium: ${this.utmUrlParams.utm_medium}` : '') +
                    (this.utmUrlParams.utm_campaign ? ` | Utm Campaign: ${this.utmUrlParams.utm_campaign}` : '') +
                    (this.utmUrlParams.utm_content ? ` | Utm Content: ${this.utmUrlParams.utm_content}` : '') +
                    (this.utmUrlParams.utm_term ? ` | Utm Term: ${this.utmUrlParams.utm_term}` : ''),

                    utmSource: this.utmUrlParams.utm_source ? this.utmUrlParams.utm_source : '',
                    utmMedium: this.utmUrlParams.utm_medium ? this.utmUrlParams.utm_medium : '',
                    utmCampaign: this.utmUrlParams.utm_campaign ? this.utmUrlParams.utm_campaign : '',
                    utmName: this.utmUrlParams.utm_source ? 'Сайт жилого комплекса - The ONE' : 'UTM отсутствует - The ONE',
                    utmContent: this.utmUrlParams.utm_content ? this.utmUrlParams.utm_content : '',
                    utmTerm: this.utmUrlParams.utm_term ? this.utmUrlParams.utm_term : '',
                    utmCode: this.generateUniqueUTMCode(),
                }
                this.$store.dispatch('sendFormDataToCRM', dataForm).then((response) => {
                    if (response.status == 200) {
                        this.formVisible = false;
                        counter++;
                        localStorage.setItem('TheOne_submissionCounter', counter);
                        localStorage.setItem('TheOne_lastSubmissionTime', time);
                        window.dataLayer.push({'event' : 'form_sent'});
                    } else {
                        alert('Ошибка при отправке формы - обратитесь в Call Center');
                    }
                });
            },
            normalizePhone(phone) {
                const digits = phone.replace(/\D/g, '');
                if (digits.length !== 11 || !digits.startsWith('7')) {
                    return null;
                }
                const code = digits.slice(1, 4);
                const part1 = digits.slice(4, 7);
                const part2 = digits.slice(7, 9);
                const part3 = digits.slice(9, 11);
                return `+7 ${code} ${part1} ${part2} ${part3}`;
            },
            getCurrentMinutes() {
                return Math.floor(new Date().getTime() / (1000 * 60));
            },
            closeFormModal() {
                cookie.set('theone_form_land_modal_timer', true, { expires: this.formSetUp.form_drop_modal.minutes + 'm' });
                this.$store.commit('Open_FormLandModal', false);
            },
            generateUniqueUTMCode() {
                const lengthstr = 10;
                const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
                const charsLength = chars.length

                const array = new Uint8Array(lengthstr)
                crypto.getRandomValues(array)

                let result = ''
                for (let i = 0; i < lengthstr; i++) {
                    result += chars[array[i] % charsLength]
                }
                return result
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/forms/form-land-modal.scss';
</style>